import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {},
  title: {
    ...theme.typography.body1,
    fontWeight: 500,
    color: theme.palette.text.primary
  },
  btnGroup: {
    marginTop: 40
  },
  button: {
    maxWidth: 199,
    '& .secondary': {
      marginRight: 14
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 151
    }
  }
}));

export default useStyles;
